<template>
  <v-container fluid>
    <material-card icon="mdi-clipboard-text" inline title="category">
      <v-card flat class="px-2"> </v-card>
      <v-card-actions>
        <a @click="$router.back()">
          <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top>
            <v-icon left>mdi-arrow-left</v-icon>back
          </v-btn>
          <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1"
            class="mr-n2 mt-10" style="opacity:.6;">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </a>
      </v-card-actions>
      <v-card-component>
        <v-card-text class="pt-0 pr-1"
          :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp }">
          <v-card-title>
            <v-spacer></v-spacer>
          </v-card-title>
          <v-text-field
            :class="{ 'mr-0': $vuetify.breakpoint.xs, 'mr-5': $vuetify.breakpoint.smAndUp }"
            v-model="search" append-icon="mdi-magnify" class="ml-auto mb-2" label="Search"
            hide-details single-line style="max-width:350px;" />
          <v-btn class="mr-3" elevation="1" color="success" @click="getCategories()">
            <v-icon left>mdi-magnify</v-icon>Search
          </v-btn>
          <v-btn v-on:click="
              () => {
                $router.push({ name: 'addAuditCategory' })
              }
            " v-if="isWrite" elevation="1" :class="{ 'mt-2': $vuetify.breakpoint.xs }"
            color="accent">
            <v-icon left>mdi-plus</v-icon>
            Add
          </v-btn>
        </v-card-text>
        <v-divider class="my-0 py-0"></v-divider>
        <v-data-table :headers="headers" :items="tableData" show-expand disable-pagination
          hide-default-footer>
          <template v-slot:item.isActive="{ item }">
            {{ item.isActive ? 'Active' : 'Inactive' }}
          </template>

          <template v-slot:item.acadAuditCategoryClassMaps="{ item }">
            <ul>
              <div v-for="(values, index) in item.acadAuditCategoryClassMaps" :key="values.id">
                <li v-if="index<=2">
                  <v-tooltip bottom :disabled="item.acadAuditCategoryClassMaps.length<=2">
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">{{ values.studentClass.name }}</span>
                      <span v-if="index===2 && item.acadAuditCategoryClassMaps.length>2">...</span>
                    </template>
                    <div v-html="item.tooltip"> </div>
                  </v-tooltip>
                </li>
              </div>
            </ul>
          </template>

          <template v-slot:item.actions="{ item }">
            <router-link :to="{ name: 'editCategory', params: { categoryId: item.id } }">
              <v-btn color="success" class="px-2 ml-1 ma-1" min-width="0" small>
                <v-icon small> mdi-pencil </v-icon>
              </v-btn>
            </router-link>
            <v-btn v-if="item.isActive===true" @click="deleteCategory(item)" color="error"
              class="px-2 ml-1 ma-1" min-width="0" small>
              <v-icon small> mdi-delete</v-icon>
            </v-btn>
            <v-btn v-if="item.isActive===false" @click="deleteCategory(item)" color="warning"
              class="px-2 ml-1 ma-1" min-width="0" small>
              <v-icon small> mdi-restore</v-icon>
            </v-btn>
          </template>

          <template v-slot:no-data>
            <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length" class="pt-4 pb-4">
              <label class="font-weight-medium body-2">Parameters </label>
              <ul>
                <li v-for="(prm, index) in item.acadAuditParameters" :key="prm.id">
                  {{index+1}}. {{ prm.name }}
                </li>
              </ul>
            </td>
          </template>
        </v-data-table>
        <!--Pagination start-->
        <v-row>
          <v-col cols="4" sm="3">
            <v-select v-model="pageSize" :items="pageSizes" label="Items per Page"
              @change="handlePageSizeChange"></v-select>
          </v-col>
          <v-col cols="12" sm="9">
            <v-pagination v-model="page" :length="totalPages" :total-visible="totalPages"
              @input="handlePageChange">
            </v-pagination>
          </v-col>
        </v-row>
        <!--Pagination end-->
      </v-card-component>
    </material-card>
  </v-container>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import MaterialCard from '@/components/template/MaterialCard'
import VCardComponent from '@/components/template/VCardComponent'
export default {
  components: { VCardComponent, MaterialCard },
  data () {
    return {
      isWrite: true,
      search: '',
      tableData: [],
      page: 1,
      pageSize: 10,
      pageSizes: [5, 10, 20],
      totalPages: 0,
      headers: [
        { text: 'Name', value: 'name', sortable: true },
        { text: 'Class', value: 'acadAuditCategoryClassMaps', sortable: false },
        { text: 'Type', value: 'type' },
        // { text: 'Status', value: 'isActive' },
        { text: 'Actions', value: 'actions', align: 'center', sortable: false }
      ]
    }
  },
  created: async function () {
    await this.getCategories()
  },
  methods: {
    getCategories: async function () {
      try {
        let data = await http.get(`${CONSTANTS.API_URL}/api/center-audit/category`, {
          params: {
            classIsActive: true,
            page: this.page - 1,
            size: this.pageSize,
            search: this.search
          }
        })
        this.totalPages = data.data.totalPages
        this.tableData = data.data.rows.map((item) => {
          item.tooltip = ''
          item.acadAuditCategoryClassMaps.map((val, index) => {
            if (item.acadAuditCategoryClassMaps.length - 1 === index) {
              item.tooltip += `${val.studentClass.name}<br/>`
            } else {
              item.tooltip += `${val.studentClass.name},<br/>`
            }
          })
          return item
        })
        console.log('table data', this.tableData)
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
      }
    },
    deleteCategory (item) {
      this.$buefy.dialog.confirm({
        type: 'is-danger',
        title: 'Alert',
        hasIcon: true,
        message: `Are you sure to ${item.isActive === true ? 'delete' : 'restore'} this category ?`,
        onConfirm: async () => {
          await http.get(`${CONSTANTS.API_URL}/api/center-audit/category/status/${item.id}`)
          this.getCategories()
        }
      })
    },
    okMsg (msg) {
      return this.$dialog.info({
        text: msg,
        title: 'Success'
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    },
    handlePageChange: function () {
      console.log(`Page: ${this.page}`)
      this.getCategories()
    },
    handlePageSizeChange: function () {
      console.log(`Page Size: ${this.pageSize}`)
      this.getCategories()
    }
  }
}
</script>

<style scoped>
.tooltip-content {
  max-height: 100px;
  overflow-y: scroll;
}
.tooltip-color {
  color: #fff;
  background-color: gray;
}
</style>
